const HolidayPresentPink = ({
  className,
  height,
  width,
}: {
  className?: string
  height?: string
  width?: string
}) => {
  const uniqueId = Math.random()
  return (
    <svg
      className={className}
      fill="transparent"
      height={height || 120}
      viewBox="0 0 97 120"
      width={width || 97}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`paint0_linear_${uniqueId}`}
          x1="12.5"
          x2="85.6524"
          y1="115.5"
          y2="39.7165"
        >
          <stop offset="0.0795732" stopColor="#FF6D4E" />
          <stop offset="0.772297" stopColor="#FED7FF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`paint1_linear_${uniqueId}`}
          x1="12.5"
          x2="85.6524"
          y1="115.5"
          y2="39.7165"
        >
          <stop offset="0.0795732" stopColor="#FF6D4E" />
          <stop offset="0.772297" stopColor="#FED7FF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`paint2_linear_${uniqueId}`}
          x1="12.5"
          x2="85.6524"
          y1="115.5"
          y2="39.7165"
        >
          <stop offset="0.0795732" stopColor="#FF6D4E" />
          <stop offset="0.772297" stopColor="#FED7FF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`paint3_linear_${uniqueId}`}
          x1="12.5"
          x2="85.6524"
          y1="115.5"
          y2="39.7165"
        >
          <stop offset="0.0795732" stopColor="#FF6D4E" />
          <stop offset="0.772297" stopColor="#FED7FF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`paint4_linear_${uniqueId}`}
          x1="32.9998"
          x2="61.9973"
          y1="122"
          y2="54.9989"
        >
          <stop stopColor="#6E3264" />
          <stop offset="1" stopColor="#A0DCFF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`paint5_linear_${uniqueId}`}
          x1="-3.5"
          x2="71.8213"
          y1="56"
          y2="19.63"
        >
          <stop stopColor="#6E3264" />
          <stop offset="1" stopColor="#A0DCFF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`paint6_linear_${uniqueId}`}
          x1="-3.5"
          x2="71.8213"
          y1="56"
          y2="19.63"
        >
          <stop stopColor="#6E3264" />
          <stop offset="1" stopColor="#A0DCFF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`paint7_linear_${uniqueId}`}
          x1="-3.5"
          x2="71.8213"
          y1="56"
          y2="19.63"
        >
          <stop stopColor="#6E3264" />
          <stop offset="1" stopColor="#A0DCFF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`paint8_linear_${uniqueId}`}
          x1="34.4998"
          x2="56.4735"
          y1="55.9999"
          y2="43.4539"
        >
          <stop stopColor="#6E3264" />
          <stop stopColor="#754B7A" />
          <stop offset="1" stopColor="#A0DCFF" />
        </linearGradient>
      </defs>
      <path
        d="M84 116.308V117H17.6918C14.5479 117 12 115.99 12 114.753V57.2471C12 56.0096 14.5479 55 17.6918 55H84V116.316V116.308Z"
        fill={`url(#paint0_linear_${uniqueId})`}
      />
      <path
        d="M12.6934 39.9658L40.179 40.1455L40.1735 40.7209L40.0841 54.7429L40.0746 55.4208L8.69729 55.2193C7.46639 55.2165 6.48013 54.2089 6.49429 52.9784L6.56089 42.147C6.57504 40.9165 7.57719 39.9244 8.80218 39.9326L12.6879 39.9599L12.6934 39.9658Z"
        fill={`url(#paint1_linear_${uniqueId})`}
      />
      <path
        d="M41.491 39.9658L68.9766 40.1455L68.9711 40.7209L68.8817 54.7429L68.8722 55.4208L37.4949 55.2193C36.264 55.2165 35.2777 54.2089 35.2919 52.9784L35.3585 42.147C35.3727 40.9165 36.3748 39.9244 37.5998 39.9326L41.4855 39.9599L41.491 39.9658Z"
        fill={`url(#paint2_linear_${uniqueId})`}
      />
      <path
        d="M83.0515 39.9658L55.5659 40.1455L55.5714 40.7209L55.6608 54.7429L55.6703 55.4208L87.0476 55.2193C88.2785 55.2165 89.2648 54.2089 89.2506 52.9784L89.184 42.147C89.1699 40.9165 88.1677 39.9244 86.9427 39.9326L83.057 39.9599L83.0515 39.9658Z"
        fill={`url(#paint3_linear_${uniqueId})`}
      />
      <path
        d="M56.4799 115.567V116.726H40.2278V116.042V55.9619V55.3982H56.4799V55.6076V115.567Z"
        fill={`url(#paint4_linear_${uniqueId})`}
      />
      <path
        d="M56.48 56H82.2596C83.4918 56 84.4904 56.9986 84.4904 58.2228V115.105C84.4904 116.329 83.4918 117.328 82.2596 117.328H14.2308C12.9986 117.328 12 116.329 12 115.105V58.2228C12 56.9986 12.9986 56 14.2308 56H56.48Z"
        stroke="#6E3264"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="3.56587"
      />
      <path
        d="M40.2278 55.962V116.042"
        stroke="#6E3264"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="3.56587"
      />
      <path
        d="M56.48 55.6077V115.567"
        stroke="#6E3264"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="3.56587"
      />
      <path
        d="M52.3071 39.6933C57.1502 33.9223 64.2847 25.9674 68.1301 24.4087C74.2979 21.9098 81.3395 24.8765 83.8443 31.0389C85.117 34.1835 84.9787 37.5577 83.7084 40.4428L52.018 40.2347C52.1102 40.0617 52.1966 39.8941 52.283 39.7265C52.2889 39.721 52.2894 39.7097 52.3071 39.6933Z"
        fill={`url(#paint5_linear_${uniqueId})`}
      />
      <path
        d="M44.0919 39.6212C44.1927 39.8133 44.2825 39.9935 44.3837 40.1741L12.6932 39.966C11.468 37.0626 11.3668 33.6905 12.6921 30.5681C15.2757 24.4291 22.3527 21.5612 28.4972 24.1507C32.3149 25.7654 39.3345 33.7864 44.0919 39.6212Z"
        fill={`url(#paint6_linear_${uniqueId})`}
      />
      <path
        d="M48.4087 7.65326C55.0694 7.69274 60.4352 13.1297 60.3844 19.79C60.3617 23.8469 55.8329 33.0782 52.296 39.6927C52.2782 39.7091 52.2723 39.7146 52.2719 39.726C52.1172 39.8909 51.9794 40.0622 51.8475 40.2279L44.5431 40.1803C44.3964 39.9978 44.2441 39.8096 44.0919 39.6212C40.6376 32.9657 36.2493 23.6859 36.2774 19.6349C36.3228 12.9687 41.7538 7.60832 48.4142 7.65917L48.4087 7.65326Z"
        fill={`url(#paint7_linear_${uniqueId})`}
      />
      <path
        d="M56.4397 40.2603L56.4367 40.4824L56.3408 54.3789L56.3348 55.547L40.0854 55.4327L40.0894 54.749L40.1788 40.7269L40.1843 40.1515L44.3892 40.18L44.5431 40.1803L51.853 40.2339L52.0127 40.2288L56.4397 40.2603Z"
        fill={`url(#paint8_linear_${uniqueId})`}
      />
      <path
        d="M40.179 40.7267L40.0896 54.7488"
        stroke="#6E3264"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="3.56587"
      />
      <path
        d="M56.4365 40.4825L56.3406 54.3789"
        stroke="#6E3264"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="3.56587"
      />
      <path
        d="M52.2773 39.7321C52.191 39.8996 52.1046 40.0672 52.0123 40.2403"
        stroke="#6E3264"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="3.52747"
      />
      <path
        d="M44.3892 40.1799C44.288 39.9993 44.1928 39.8132 44.0975 39.6271C40.6432 32.9715 36.2548 23.6918 36.2829 19.6408C36.3283 12.9746 41.7593 7.61426 48.4196 7.66512C55.0804 7.7046 60.4462 13.1416 60.3953 19.8019C60.3727 23.8588 55.8439 33.0901 52.3069 39.7046"
        stroke="#6E3264"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="3.56587"
      />
      <path
        d="M83.7086 40.4428C84.9734 37.5518 85.1172 34.1835 83.8445 31.0389C81.3342 24.8707 74.2981 21.9099 68.1303 24.4088C64.2903 25.9733 57.1503 33.9223 52.3073 39.6933C52.2895 39.7097 52.2836 39.7152 52.2831 39.7265C52.1285 39.8914 51.9907 40.0627 51.8588 40.2285"
        stroke="#6E3264"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="3.56587"
      />
      <path
        d="M12.6988 39.972C11.4681 37.0626 11.3669 33.6905 12.6922 30.5681C15.2758 24.4291 22.3528 21.5613 28.4973 24.1508C32.315 25.7655 39.3346 33.7865 44.0921 39.6213C44.2442 39.8096 44.4023 39.9925 44.5431 40.1804"
        stroke="#6E3264"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="3.56587"
      />
      <path
        d="M83.7088 40.4427L87.5946 40.47C88.8255 40.4728 89.8117 41.4804 89.8035 42.7054L89.7255 53.5364C89.7227 54.7674 88.7151 55.7536 87.4901 55.7454L56.3295 55.541L40.08 55.4268L8.70276 55.2253C7.47186 55.2225 6.48561 54.2149 6.49976 52.9845L6.56636 42.153C6.58052 40.9225 7.58266 39.9304 8.80765 39.9386L12.6934 39.9659L40.179 40.1456L44.3839 40.174L44.5491 40.1748L51.8536 40.2225L52.0188 40.2233L56.4403 40.2488L83.7093 40.4314L83.7088 40.4427Z"
        stroke="#6E3264"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="3.56587"
      />
    </svg>
  )
}

export default HolidayPresentPink
